import getMiddleNameInitial from './getMiddleNameInitial';

const getMemberFullName = (member: any) => {
  if (!member) {
    return {
      firstName: '',
      middleName: '',
      middleNameInitial: '',
      lastName: '',
    };
  }

  const fhirName = member?.name?.[0] ?? member?.registration?.[0]?.profile?.name?.[0];

  if (fhirName) {
    const firstName = fhirName.given?.[0]?.trim() ?? '';
    const lastName = fhirName.family?.trim() ?? '';
    const middleName = fhirName.given?.[1]?.trim() ?? '';
    const middleNameInitial = getMiddleNameInitial(middleName);

    return {
      firstName,
      middleName,
      middleNameInitial,
      lastName,
    };
  }

  const displayParts = member?.entity?.display?.trim().split(/\s+/).filter(Boolean) ?? [];
  const firstName = displayParts[0] ?? '';
  const lastName = displayParts.length > 1 ? displayParts[displayParts.length - 1] ?? '' : '';
  const middleName = displayParts.length > 2 ? displayParts.slice(1, -1).join(' ') : '';
  const middleNameInitial = getMiddleNameInitial(middleName);

  return {
    firstName,
    middleName,
    middleNameInitial,
    lastName,
  };
};

export default getMemberFullName;
